import React from 'react'
import cn from 'classnames'
import PlayArrow from '../assets/play-arrow.svg?svgr-webpack'

const PlayButton = () => (
  <div
    className={cn(`
      relative h-80 w-80
      transform rounded-full
      bg-white bg-opacity-50
      shadow-elevated transition group-hover:scale-110
    `)}
  >
    <div
      className={cn(`
        absolute inset-0
        m-5 flex items-center
        justify-center rounded-full bg-white
        text-Brand
      `)}
    >
      <PlayArrow className="ml-6" />
    </div>
  </div>
)

export default PlayButton
